// Generated by CoffeeScript 2.7.0
var Admin__Settings__AttendanceController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import SettingsAttendance from 'trunks/vue/admin/components/settings/settings_container/settings_attendance.js';

export default Admin__Settings__AttendanceController = (function() {
  class Admin__Settings__AttendanceController extends Skylark.App.BaseController {
    show() {
      this._generateSettingsSidebarView('settings__basic');
      return Skylark.Libs.Ajax.get('/admin/settings/attendance.json', {
        success: (data) => {
          return new SettingsAttendance({
            el: DomMaster.find("#js-settings-attendance").node,
            propsData: {
              activeTab: 'attendance',
              attendance: data,
              currentIp: this.getVars().current_ip
            }
          });
        }
      });
    }

  };

  Admin__Settings__AttendanceController.include(GenerateMorePopover);

  Admin__Settings__AttendanceController.include(SettingsNavigator);

  return Admin__Settings__AttendanceController;

}).call(this);
